import { Control } from 'react-hook-form'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { TradeFormSchema, BridgeToken } from '../../logic/useTrade'
import { SearchableAssetSelector } from '../dropdown/SearchableAssetSelector'
import { ControlledMultiSelectorAssetInput } from '@/ui/organisms/multi-selector/ControlledMultiSelectorAssetInput'
import { TokenWithBalance } from '@/domain/common/types'

interface FromProps {
  control: Control<TradeFormSchema>
  assets: (TokenWithBalance | BridgeToken)[]
  selectedAsset: TokenWithBalance | BridgeToken
  maxSelectedFieldName?: string
  maxValue: NormalizedUnitNumber
  changeToken: (newSymbol: TokenSymbol, isL1: boolean) => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSetMax?: (max: NormalizedUnitNumber) => void
}

export function From(props: FromProps) {
  const { control, assets, selectedAsset, maxSelectedFieldName, changeToken, onChange, onSetMax, maxValue } = props

  return (
    <Panel.Wrapper className="mt-2 p-4 pb-5">
      <div className="flex flex-row items-center gap-1">
        <Typography variant="h4" className="py-3 font-semibold">
          From
        </Typography>
      </div>

      <div>
        <div className="mt-2 flex flex-row items-start gap-2">
          <ControlledMultiSelectorAssetInput
            fieldName="from.value"
            control={control}
            disabled={false}
            token={selectedAsset.token}
            resetBorrowStatus={() => {}}
            max={maxValue}
            balance={selectedAsset.balance}
            maxSelectedFieldName={maxSelectedFieldName}
            customOnChange={onChange}
            onSetMax={onSetMax}
          />

          <SearchableAssetSelector
            assets={assets}
            selectedAsset={selectedAsset}
            setSelectedAsset={changeToken}
            isDestination={false}
          />
        </div>
      </div>
    </Panel.Wrapper>
  )
}
